export default {
  blue: '#4451DA',
  darkBlue: '#252F81',
  yellow: '#FECA30',
  darkYellow: '#FFB800',
  black: '#333333',
  gray: '#999999',
}
